var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.visible, "max-width": "45rem", persistent: "" },
      on: { input: _vm.close },
    },
    [
      _c(
        "v-card",
        { attrs: { loading: _vm.loading, disabled: _vm.loading } },
        [
          _c("v-card-title", [
            _vm._v(_vm._s(_vm.$t("pages.settings.users.addDialog.title"))),
          ]),
          _c("v-divider", { staticClass: "w-100" }),
          _c("validation-observer", {
            ref: "observer",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ invalid }) {
                  return [
                    _c(
                      "v-card-text",
                      { staticClass: "pt-5" },
                      [
                        _c("validation-provider", {
                          attrs: { name: "firstName", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("v-text-field", {
                                      staticClass: "mb-2",
                                      attrs: {
                                        outlined: "",
                                        "error-messages": errors,
                                        autocomplete: "off",
                                        name: "addUserFirstName",
                                        label: _vm.$t(
                                          "pages.settings.users.addDialog.firstName"
                                        ),
                                      },
                                      model: {
                                        value: _vm.form.firstName,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "firstName", $$v)
                                        },
                                        expression: "form.firstName",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("validation-provider", {
                          attrs: { name: "lastName", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("v-text-field", {
                                      staticClass: "mb-2",
                                      attrs: {
                                        outlined: "",
                                        "error-messages": errors,
                                        autocomplete: "off",
                                        name: "addUserLastName",
                                        label: _vm.$t(
                                          "pages.settings.users.addDialog.lastName"
                                        ),
                                      },
                                      model: {
                                        value: _vm.form.lastName,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "lastName", $$v)
                                        },
                                        expression: "form.lastName",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("validation-provider", {
                          attrs: { name: "email", rules: "required|email" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("v-text-field", {
                                      staticClass: "mb-2",
                                      attrs: {
                                        type: "email",
                                        outlined: "",
                                        "error-messages": errors,
                                        autocomplete: "off",
                                        name: "addUserEmail",
                                        label: _vm.$t(
                                          "pages.settings.users.addDialog.email"
                                        ),
                                      },
                                      model: {
                                        value: _vm.form.email,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "email", $$v)
                                        },
                                        expression: "form.email",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("validation-provider", {
                          attrs: { name: "password", rules: "required|min:6" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("v-text-field", {
                                      attrs: {
                                        outlined: "",
                                        "error-messages": errors,
                                        autocomplete: "new-password",
                                        name: "addUserPassword",
                                        label: _vm.$t(
                                          "pages.settings.users.addDialog.password"
                                        ),
                                      },
                                      model: {
                                        value: _vm.form.password,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "password", $$v)
                                        },
                                        expression: "form.password",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _c("v-divider", { staticClass: "w-100" }),
                    _c(
                      "v-card-actions",
                      { staticClass: "justify-end" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              text: "",
                              color: "error",
                              disabled: _vm.loading,
                            },
                            on: { click: _vm.close },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "primary",
                              elevation: 0,
                              disabled: _vm.loading || invalid,
                            },
                            on: { click: _vm.save },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "pages.settings.users.addDialog.submit"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }